var _g, _text, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "cancelled_status",
    "data-name": "cancelled status",
    xmlns: "http://www.w3.org/2000/svg",
    width: 85,
    height: 22,
    viewBox: "0 0 86 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "needs"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_287",
    "data-name": "Rectangle 287",
    fill: "rgba(162,17,16,0.05)",
    stroke: "#a21110",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 85,
    height: 22,
    rx: 4.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 85,
    height: 21,
    rx: 4,
    fill: "none"
  })))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "Cancelled",
    "data-name": "Cancelled",
    transform: "translate(24 15)",
    fill: "#a21110",
    fontSize: 12,
    fontFamily: "Lato-Regular, Lato"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Cancelled"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "error_FILL0_wght400_GRAD0_opsz48",
    d: "M86.611,185.917a.536.536,0,1,0-.388-.157A.528.528,0,0,0,86.611,185.917Zm-.446-2.529h.992v-4.182h-.992Zm.451,5.835a6.4,6.4,0,0,1-2.57-.521,6.679,6.679,0,0,1-3.525-3.526,6.617,6.617,0,0,1,0-5.146,6.616,6.616,0,0,1,1.422-2.1,6.786,6.786,0,0,1,2.1-1.413,6.618,6.618,0,0,1,5.146,0,6.608,6.608,0,0,1,3.51,3.512,6.614,6.614,0,0,1,0,5.144,6.753,6.753,0,0,1-1.413,2.1,6.675,6.675,0,0,1-2.1,1.422A6.4,6.4,0,0,1,86.616,189.223Zm0-.992a5.615,5.615,0,1,0-3.984-1.645A5.4,5.4,0,0,0,86.62,188.232ZM86.612,182.612Z",
    transform: "translate(-72.663 -171.729)",
    fill: "#a21110"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelled);
export default __webpack_public_path__ + "static/media/cancelled.1766482015c448bf5978992c6f5a583e.svg";
export { ForwardRef as ReactComponent };